import { render } from "./tabSucursales.vue?vue&type=template&id=7d0f0eb4&scoped=true"
import script from "./tabSucursales.vue?vue&type=script&lang=js"
export * from "./tabSucursales.vue?vue&type=script&lang=js"

import "./tabSucursales.vue?vue&type=style&index=0&id=7d0f0eb4&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0f0eb4"]])

export default __exports__